import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useHistory, useParams } from 'react-router-dom';
import { PrimaryButton } from 'office-ui-fabric-react';
import TextButton from '../../components/TextButton';
import ContractTermsForm from '../../components/ContractTermsForm';
import Module from '../../components/Module';
import ModuleContent from '../../components/ModuleContent';
import Main from '../../components/Main';
import PageTitle from '../../components/PageTitle';
import SavingIndicator from '../../components/SavingIndicator';
import styles from './EditContractTerms.style';

const EditContractTerms = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const ref = useRef();
  const { contractAddress } = useParams();
  const contract = useSelector(state => get(state, `entities.contracts.${contractAddress}`, {}));

  // if the contract isn't approved, then you shouldn't be able to edit it here
  // in this user flow
  useEffect(() => {
    if (contract.approvalStatus && contract.approvalStatus !== 'Approved' && !isSubmitting) {
      history.push(`/contracts/${contractAddress}`);
    }
  }, [history, contract.approvalStatus, contractAddress, isSubmitting]);

  const handleCancel = () => {
    history.push(`/contracts/${contractAddress}`);
  };

  const handleSave = async () => {
    setIsSubmitting(true);

    if (ref.current.dirty) {
      await ref.current.submitForm();
      if (ref.current && !isEmpty(ref.current.errors)) {
        setIsSubmitting(false);
      }
    } else {
      const invalidFields = await ref.current.validateForm();
      if (isEmpty(invalidFields)) {
        history.push(`/contracts/${contractAddress}`);
      } else {
        setIsSubmitting(false);
      }
    }
  };

  const handleSuccess = () => {
    history.push(`/contracts/${contractAddress}`);
  };

  const handleFailure = () => setIsSubmitting(false);

  return (
    <>
      <PageTitle>Edit Contract Terms</PageTitle>

      <Main>
        <Module>
          <ModuleContent>
            <ContractTermsForm
              address={contractAddress}
              onSuccess={handleSuccess}
              onFailure={handleFailure}
              ref={ref}
            />
          </ModuleContent>
        </Module>

        <div className={styles.buttonContainer}>
          <TextButton
            className={styles.cancelButton}
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </TextButton>
          {!isSubmitting ? (
            <PrimaryButton type="submit" onClick={handleSave} disabled={isSubmitting}>
              Submit for Approval
            </PrimaryButton>
          ) : (
            <SavingIndicator />
          )}
        </div>
      </Main>
    </>
  );
};

export default EditContractTerms;
